import { AxiosResponse } from "axios";

import { GetTopRefereesType, TopRefereeModel } from "shared/types";

export const convertAnalytics = ({ data }: AxiosResponse<GetTopRefereesType>): TopRefereeModel[] => data.analytics;
